import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceService } from 'src/app/business-service/invoice/invoice.service';
import { PaymentService } from 'src/app/business-service/payments/payment.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-invoice-payments',
  templateUrl: './invoice-payments.component.html',
  styleUrls: ['./invoice-payments.component.scss'],
})
export class InvoicePaymentsComponent implements OnInit {

  @Input() leadId: any;

  doesInvoiceExists: boolean = false;

  clientInvoice: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  clientInvoiceColumns: any = [
    { key: "invoiceId", colName: "ID", showColumn: true, routePath: '/invoice/details/' },
    { key: "invoiceDate", colName: "Invoice Date", showColumn: true, formatter: "date" },
    { key: "dueDate", colName: "Due Date", showColumn: true, formatter: "date" },
    { key: "totalAmount", colName: "Amount", showColumn: true, formatter: "currency: INR" },
    { key: "balanceAmount", colName: "Balance", showColumn: true, formatter: "currency: INR" },
    { key: "status", colName: "Status", showColumn: true }
  ]

  invoiceOptionsValues: any =
    {
      idKey: 'invoiceId',
      options: [
        {
          value: "View",
          path: "details"
        },
        {
          value: "Edit",
          path: "edit"
        },
        {
          value: "Add Payment",
          path: "addPayment"
        },
        {
          value: "Delete",
          path: "delete"
        }
      ]
    }

  allPaymentsOfLead: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  allPaymentsOfLeadColumns: any = [
    {
      key: "paymentId",
      colName: "ID",
      showColumn: true,
    },
    {
      key: "paymentMethod",
      colName: "Method",
      showColumn: true,
    },
    {
      key: "paymentDate",
      colName: "Date",
      showColumn: true,
      formatter: 'date'
    },
    {
      key: "requestedAmount",
      colName: "Paid",
      showColumn: true,
      formatter: "currency : INR"
    },
    {
      key: "updatedBalanceAmount",
      colName: "Total Advance Received",
      showColumn: true,
      formatter: "currency : INR"
    },
    {
      key: "referenceNumber",
      colName: "Ref Number",
      showColumn: true
    }
  ];

  constructor(
    private _reloadService: ComponentReloadService,
    private _invoiceService: InvoiceService,
    private _paymentService: PaymentService,
    private _modalPopupService: ModalsService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _router: Router
  ) { }

  ngOnInit() {
    this._reloadService.reloadInvoices$.subscribe(() => {
      this.getDefaultInvoicesForLead()
    });
    this._reloadService.reloadPayment$.subscribe(() => {
      this.getDefaultPayments()
    });

    this.getDefaultInvoicesForLead();
    this.getDefaultPayments();
  }

  // Get defalut invoices for lead
  getDefaultInvoicesForLead() {
    this._invoiceService.getAllInvoiceForLead(this.leadId, null, null, null).subscribe((data) => {
      this.clientInvoice = data;
      if (data?.data?.length > 0) {
        this.doesInvoiceExists = true;
      }
    })
  }

  // Invoice funcitons

  addInvoiceForClinet() {
    this._modalPopupService.openInvoiceForm(null, this.leadId, null, () => {
      this.getDefaultInvoicesForLead();
    })
  }

  async deleteInvoiceRow(data: any) {
    if (await this._globalService.confirmActionPopup("Confirm To Delete Invoice")) {
      this._invoiceService.deleteInvoice(data).subscribe((data) => {
        this._responseNotificationService.showMessage("Invoice deleted successfully")
      })
    }
  }

  editInvoiceOpen(data: any) {
    this._modalPopupService.openInvoiceForm(data, null, null, () => {
    })
  }

  viewInvoice(data: any) {
    this._router.navigate([`invoice/details/${data}`]);
  }

  addPaymentForInvoice(id: any) {
    this._invoiceService.getInvoiceDetails(id).subscribe((data) => {
      if (data.balanceAmount > 0) {
        this._modalPopupService.openPaymentForm(null, id, false)
      } else {
        this._globalService.customAlert("All payments settled!");
      }
    })
  }

  getDefaultPayments() {
    this._paymentService.getAllPaymentsOfLead(this.leadId, null, null, null).subscribe((data) => {
      this.allPaymentsOfLead = data;
    })
  }

  addPaymentToLead() {
    this._modalPopupService.openPaymentForm(null, null, false, this.leadId)
  }

  refundPaymentToLead() {
    this._modalPopupService.openPaymentForm(null, null, true, this.leadId)
  }

}
